import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ReceivablesImportRow} from "../interface/receivables-import-row";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";
import {ReceivablesPaymentImportRow} from "../interface/receivables-payment-import-row";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesPaymentImportRowService {
  public readonly rowListSubject: ReplaySubject<CountedAndPaginated<ReceivablesPaymentImportRow>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesPaymentImportRow>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  public loadList(page: number, pageSize: number, filters: object, serviceKey?: string,
                  sort?: { sortBy?: string, sortOrder?: string }): void
  {
    this.httpClient.get(`/rest/crm/receivables-payment-import-row${serviceKey}?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<ReceivablesPaymentImportRow>) => {
          this.rowListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.rowListSubject.error(error);
        }
      });
  }

  public get(receivablesPaymentImportRowId: string): Observable<ReceivablesPaymentImportRow> {
    return this.httpClient.get(`/rest/crm/receivables-payment-import-row/${receivablesPaymentImportRowId}`)
      .pipe(first()) as Observable<ReceivablesPaymentImportRow>;
  }

  downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-payment-import-row/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  changeReceivablesBalance(formData: any, rowId: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/receivables-payment-import-row/change-receivables-balance//${rowId}`, formData)
      .pipe(first());
  }

  public sendForm(formData: object, rowId?: string): Observable<any> {
    if (rowId) {
      return this.httpClient.put(`/rest/crm/receivables-payment-import-row/${rowId}`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.httpClient.post('/rest/crm/receivables-payment-import-row', formData)
        .pipe(
          take(1)
        );
    }
  }

  public sendFormTransfer(formData: object): Observable<any> {
    return this.httpClient.post('/rest/crm/receivables-payment-import-row/transfer', formData)
      .pipe(
        take(1)
      );

  }
  public cancel(uuid: string, reason: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/receivables-payment-import-row/delete/${uuid}`, {reason})
      .pipe(first());
  }
}
